import { Typography, TypographyProps } from '@mui/material'
import { ReactNode } from 'react'

export const ResourceHeader = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="h4" sx={{ mt: 2, mb: 5, textAlign: 'center' }}>
    {children}
  </Typography>
)

interface CustomTypographyProps extends TypographyProps {
  children: ReactNode
}
export const ResourceTitle = ({ children, ...props }: CustomTypographyProps) => (
  <Typography pt={4} pb={3.5} fontWeight="bold" {...props}>
    {children}
  </Typography>
)
